import { GetterTree } from 'vuex'
import { IRootState, FeatureFlagsState } from '@/@types'
import CONSTANTS from '@/constants'

const shouldHideBlackFridayForBahPlan = () => {
  if (typeof window === 'undefined') return false
  const params = new URLSearchParams(window.location.search)
  const plan = params.get('plan')?.trim()
  const availablePlans = params.get('available_plans')
  if (!plan || !availablePlans) return false
  const normalizedPlans = availablePlans.split(',').map(p => p.trim())
  return plan === CONSTANTS.PLANS.BAH && normalizedPlans.includes(CONSTANTS.PLANS.BAH)
}

const getters: GetterTree<FeatureFlagsState, IRootState> = {
  isBlackFridayActive: state => {
    if (shouldHideBlackFridayForBahPlan()) return false
    return state?.blackFridayEnabled ?? false
  },
  isCyberMondayActive: state => {
    return state?.cyberMondayEnabled ?? false
  },
  isTCSPromoEnabled: state => {
    return state?.tcsPromoEnabled ?? false
  },
  isFlashSaleActive: state => {
    return state?.flashSaleEnabled ?? false
  },
  showB2BBanner: state => {
    return state?.showB2BBanner ?? false
  },
  premiumPlusEnabled: state => {
    return state?.premiumPlusEnabled ?? false
  },
  isSpringPromoEnabled: state => {
    return state?.springPromoEnabled ?? false
  },
  isMaySaleEnabled: state => {
    return state?.maySaleEnabled ?? false
  },
  isMayFlashSaleEnabled: state => {
    return state?.mayFlashSaleEnabled ?? false
  },
  isSummerSavingsEnabled: state => {
    return state?.summerSavingsEnabled ?? false
  },
  isJulySaleEnabled: state => {
    return state?.julySaleEnabled ?? false
  },
  showDefaultSmallPrint: state => {
    return state?.showDefaultSmallPrint ?? false
  },
  isHubspotIntegrationEnabled: state => {
    return state?.hubspotIntegration ?? false
  },
  isCerts50percentDiscountEnabled: state => {
    return state?.certs50percentDiscount ?? false
  },
  isRestrictStandAloneCertsEnabled: state => {
    return state?.restrictStandAloneCertsEnabled ?? false
  },
}

export default getters
